
    import { Options, Vue } from 'vue-class-component';
    import { api } from '@/services/Api';
    import Swal from 'sweetalert2';
    import { SMSProfileResource } from '@/models/SMS';
    import { ModalBeforeOpenEvent } from '@/models/Interfaces';

    function newEntity(): SMSProfileResource {
        return {
            Id: 0,
            Name: '',
            From: '',
            CreatedAt: null,
        };
    }

    export type OnSaveCallback = (profile: SMSProfileResource) => void;

    @Options({
        props: {
            name: String,
        },
    })
    export default class SMSProfileModal extends Vue {
        private readonly name!: string;
        public profile: SMSProfileResource = newEntity();
        public onSave: OnSaveCallback | null = null;

        get isNew() {
            return !(this.profile.Id > 0);
        }

        public async beforeOpen(event: ModalBeforeOpenEvent) {
            const id = Number(event.params?.id) || 0;
            this.onSave = event.params?.onSave || null;
            this.profile = newEntity();
            if (id > 0) {
                Swal.showLoading();
                var resp = await api.SMSGetProfile(id);

                if (resp.Error || !resp.Data) {
                    Swal.fire(resp.ErrorMessage || 'Oops..', '', 'warning').then(() => {
                        this.$vfm.hide(this.name);
                    });
                    return;
                }
                Swal.close();
                this.profile = resp.Data;
            }
        }
        public async saveProfile() {
            Swal.showLoading();
            var resp = await api.SMSSaveProfile(this.profile);
            if (resp.Error || resp.Data == null) {
                Swal.fire(resp.ErrorMessage || 'Oops..', '', 'warning');
                return;
            }
            Swal.close();
            this.$vfm.hide(this.name);
            this.profile = newEntity();
            const profile = resp.Data;
            this.$store.commit('UpdateSMSProfile', profile);
            if (this.onSave) {
                this.onSave(profile);
            }
        }
    }
